
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";
import useAnalytics from "@/hooks/use-analytics";

const NotFound = () => {
  const location = useLocation();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    // Log 404 error to analytics
    trackEvent('404_error', 'navigation', {
      page_path: location.pathname,
      full_url: window.location.href
    });
    
    // Add more detailed logging to help debug the issue
    console.error({
      message: "404 Error: Route not found",
      path: location.pathname,
      fullUrl: window.location.href,
      baseUrl: window.location.origin,
      search: location.search,
      hash: location.hash
    });
  }, [location, trackEvent]);

  return (
    <>
      <SEO
        title="Página não encontrada | 404 | Dr.Cash"
        description="A página que você está procurando não existe ou foi movida."
        noIndex={true}
      />
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
        <div className="text-center max-w-md w-full bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-4xl font-bold mb-4 text-drcash-maastricht-blue">404</h1>
          <p className="text-xl text-gray-600 mb-8">Página não encontrada</p>
          <p className="text-gray-500 mb-4 text-sm">
            A URL <code className="bg-gray-100 px-2 py-1 rounded">{location.pathname}</code> não existe ou foi movida.
          </p>
          <Link 
            to="/" 
            className="inline-block bg-drcash-caribbean-green hover:bg-drcash-tiffany-blue text-white font-medium py-2 px-6 rounded-md transition-colors"
            onClick={() => trackEvent('404_to_home_redirect', 'navigation', {
              from_path: location.pathname
            })}
          >
            Voltar à página inicial
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
